require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-our-teaching-frameworks.json") })
        }
      }, "path---learning-our-teaching-frameworks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-our-teaching-frameworks!./.cache/json/learning-our-teaching-frameworks.json
// module id = 1243
// module chunks = 231608221292675